import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";

type AnalyticsParameters = Record<string, string | number>;

const track = (eventName: string, parameters?: AnalyticsParameters) => {
  try {
    logEvent(analytics, eventName, parameters);
  } catch (error) {
    // Analytics must never interrupt gameplay (for example, when tracking is blocked).
    console.warn(`Analytics event failed: ${eventName}`, error);
  }
};

export const logStartAdventure = () => track("start_adventure");

export const logLevelStart = (level: number) => {
  track("level_start", { level, level_name: String(level) });
};

export const logLevelEndSuccess = (level: number, score: number) => {
  const parameters = { level, level_name: String(level), score, success: 1 };
  track("level_end", parameters);
  track("level_complete", { level, level_name: String(level), score });
};

export const logLevelEndFailure = (level: number, score: number) => {
  track("level_end", { level, level_name: String(level), score, success: 0 });
};

export const logGameOver = (score: number, level: number) => {
  track("game_over", { score, level, level_name: String(level) });
};

export const logAcademicAnswer = (
  questionId: string,
  answerResult: "correct" | "wrong" | "skipped",
  subject: string,
  scoreDelta: number
) => {
  track("academic_answer", {
    question_id: questionId,
    answer_result: answerResult,
    subject,
    score_delta: scoreDelta
  });
};

export const logRewardEarned = (rewardType: string, scoreDelta: number) => {
  track("earn_reward", { reward_type: rewardType, score_delta: scoreDelta });
};

export const logHazardResolution = (
  hazardType: string,
  hpDelta: number,
  survived: boolean,
  remedyUsed: string | null
) => {
  track("hazard_resolved", {
    hazard_type: hazardType,
    hp_delta: hpDelta,
    survived: survived ? 1 : 0,
    remedy_used: remedyUsed || "none"
  });
};

export const logLeaderboardView = (cachedRanks: number) => {
  track("view_leaderboard", { cached_ranks: cachedRanks });
};

export const logPostScore = (score: number, level: number) => {
  track("post_score", {
    score,
    level,
    leaderboard_id: "nebula_maze_highscores"
  });
};

export const logHouseAdImpression = (campaignId: string, platform: string, placement: string) => {
  track("house_ad_impression", { campaign_id: campaignId, platform, placement });
};

export const logHouseAdClick = (campaignId: string, platform: string, placement: string) => {
  track("house_ad_click", { campaign_id: campaignId, platform, placement });
};
